import { useCallback, useEffect, useRef } from 'react';

import { componentsRegistry } from '../services/componentsRegistry';
import { useStores } from '../stores/useStores';

import { useMissedCountrySettings } from './useMissedCountrySettings';
import { useMissedWelcomeBonus } from './useMissedWelcomeBonus';

export function useForceDialogsBeforeFeatureManager() {
  const { uiStore, portalStore, authStore } = useStores();

  const { checkCountrySetMissed } = useMissedCountrySettings();
  const { checkWelcomeBonusMissed, showWelcomeBonusDialog } = useMissedWelcomeBonus();
  const { authStatus } = authStore;

  const isAllChecksPassed = useRef(false);

  const openPostSignUpWizard = useCallback(() => {
    portalStore.openPortal(componentsRegistry.getComponent('postSignUpWizard'), { persistent: true });
  }, [portalStore]);

  useEffect(() => {
    if (
      !portalStore.isVisible &&
      uiStore.openDialog?.dialog === null &&
      !isAllChecksPassed.current &&
      authStatus === 'authenticated'
    ) {
      const isCountrySetMissed = checkCountrySetMissed();
      const isWelcomeBonusMissed = checkWelcomeBonusMissed();

      if (isCountrySetMissed) {
        openPostSignUpWizard();
        return;
      }

      if (isWelcomeBonusMissed) {
        showWelcomeBonusDialog();
        return;
      }

      isAllChecksPassed.current = true;
    }
  }, [
    authStatus,
    openPostSignUpWizard,
    checkCountrySetMissed,
    checkWelcomeBonusMissed,
    showWelcomeBonusDialog,
    portalStore.isVisible,
    uiStore.openDialog,
  ]);
}
